import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date, opts?: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat('fr-FR', opts).format(new Date(date));
}

export function formatCurrency(amount: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount);
}

export function formatHours(hours: number): string {
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return m > 0 ? `${h}h${m.toString().padStart(2, '0')}` : `${h}h`;
}

export function statusColor(status: string): string {
  const map: Record<string, string> = {
    DRAFT: 'bg-gray-100 text-gray-700',
    SOUMISE: 'bg-amber-100 text-amber-700',
    EN_QUALIFICATION: 'bg-purple-100 text-purple-700',
    ASSIGNEE: 'bg-cyan-100 text-cyan-700',
    EN_COURS: 'bg-yellow-100 text-yellow-700',
    EN_ATTENTE_CLIENT: 'bg-orange-100 text-orange-700',
    LIVREE: 'bg-green-100 text-green-700',
    VALIDEE: 'bg-emerald-100 text-emerald-700',
    ARCHIVEE: 'bg-gray-100 text-gray-500',
    ANNULEE: 'bg-red-100 text-red-700',
    ACTIVE: 'bg-green-100 text-green-700',
    PAST_DUE: 'bg-red-100 text-red-700',
    TRIALING: 'bg-amber-100 text-amber-700',
    CANCELED: 'bg-gray-100 text-gray-500',
  };
  return map[status] ?? 'bg-gray-100 text-gray-700';
}

export function priorityColor(priority: string): string {
  const map: Record<string, string> = {
    BASSE: 'text-green-600',
    NORMALE: 'text-amber-600',
    HAUTE: 'text-orange-600',
    URGENTE: 'text-red-600',
  };
  return map[priority] ?? 'text-gray-600';
}

export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    DRAFT: 'Brouillon', SOUMISE: 'Soumise', EN_QUALIFICATION: 'En qualification',
    ASSIGNEE: 'Assignée', EN_COURS: 'En cours', EN_ATTENTE_CLIENT: 'En attente client',
    LIVREE: 'Livrée', VALIDEE: 'Validée', ARCHIVEE: 'Archivée', ANNULEE: 'Annulée',
    ACTIVE: 'Active', PAST_DUE: 'Impayé', TRIALING: 'Essai', CANCELED: 'Annulé', PAUSED: 'Suspendu',
    BASSE: 'Basse', NORMALE: 'Normale', HAUTE: 'Haute', URGENTE: 'Urgente',
  };
  return map[status] ?? status;
}
